import React, { Fragment } from "react";
import { withTranslation } from 'react-i18next';
import { withSnackbar } from 'notistack';
import { Link } from 'react-router-dom';
import {
    Grid,
    Card,
    CardHeader,
    CardContent,
    CircularProgress,
    Button,
    TableCell,
    TableRow,
    Fab,
    TableContainer,
    Paper,
    Table,
    TableHead,
    TableBody,
    Collapse,
    Box,
    TablePagination
} from "@material-ui/core";
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';
import IconButton from '@material-ui/core/IconButton';
/* import AddIcon from '@material-ui/icons/Add'; */
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import CloseIcon from '@material-ui/icons/Close';
import CheckIcon from '@material-ui/icons/Check';
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp';
import CreateOrUpdateInventory from "./CreateOrUpdateInventory";
import { getSpecificClients } from "views/clients/api/apiClients";
import SelectClient from "common/components/custom/SelectClient";
import { changeInventoryStatus, deleteInventory, getInventories, getInventoryById } from "../api/apiInventory";
import ConfirmationDialog from "common/components/ConfirmationDialog";

class Inventories extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            specificsClients: [],
            isOpen: false,
            inventories: [],
            inventoryToEdit: null,
            inventoryToDelete: null,
            isLoading: true,
            selectedClient: null,
            activePage: 0,
            totalElements: 0,
            rowsPerPage: 25,
            expandTable: false,
            collapseIndex: -1,
            reportingYearToDelete: null,
            deleteDialogOpen: false
        };
    }

    async componentDidMount() {
        this.getSpecificClients()
    }

    handleChangePage = (event, newPage) => {
        this.setState({ activePage: newPage }, () => this.getInventories(newPage, this.state.selectedClient.id))
    };

    handleChangeRowsPerPage = (event) => {
        this.setState({ rowsPerPage: parseInt(event.target.value, 10), activePage: 0 }, () => this.getInventories(this.state.activePage, this.state.selectedClient.id))
    };

    getSpecificClients = () => {
        getSpecificClients().then((response) => {
            let selectedClient = response.data.data.length > 0 ? response.data.data[0] : null
            this.setState({ specificsClients: response.data.data, selectedClient: selectedClient, isLoading: false }, selectedClient ? this.getInventories(0, selectedClient.id) : null);
        }).catch(error => {
            this.props.enqueueSnackbar(this.props.t("something_went_wrong"), { variant: 'error' });
        });
    }

    getInventories = (page, selectedClient) => {
        this.setState({ isLoading: true })
        getInventories({ params: { page: page, size: this.state.rowsPerPage } }, selectedClient).then((response) => {
            this.setState({
                inventories: response.data.data.content,
                totalElements: response.data.data.totalElements,
                isLoading: false
            });
            if (page > 0 && response.data.data.content.length === 0) {
                this.setState({ activePage: page }, () => this.getInventories(page - 1, this.state.selectedClient));
            }
        }).catch(error => {
            this.props.enqueueSnackbar(this.props.t("something_went_wrong"), { variant: 'error' });
        });
    }

    handleChange = (client) => {
        if (client !== null) {
            this.setState({ selectedClient: client }, () => this.getInventories(0, client.id))
        } else {
            this.setState({ selectedClient: null })
        }
    }

    getInventoryById = (id) => {
        getInventoryById(id).then(response => {
            this.setState({ inventoryToEdit: response.data.data, isOpen: true });
        }).catch(error => {
            this.props.enqueueSnackbar(this.props.t("error_get_inventory_by_id"), { variant: 'error' });
        });
    }

    changeInventoryStatus = (status, id) => {
        changeInventoryStatus({ params: { isActive: !status } }, id).then((response) => {
            this.props.enqueueSnackbar(this.props.t("success_update_active_status"), { variant: 'success' });
            this.getInventories(this.state.activePage, this.state.selectedClient.id)
        }).catch(error => {
            this.props.enqueueSnackbar(this.props.t("something_went_wrong"), { variant: 'error' });
        });
    }

    closeDialog = () => {
        this.setState({ isOpen: false, inventoryToEdit: null });
    }

    deleteInventory = () => {
        let { inventoryToDelete } = this.state
        deleteInventory(inventoryToDelete.id).then(response => {
            this.props.enqueueSnackbar(this.props.t("delete_message_inventory", { inventoryName: this.state.inventoryToDelete.inventoryName }), { variant: 'success' });
            this.setState({ deleteDialogOpen: false, inventoryToDelete: null, rowsPerPage: this.state.rowsPerPage }, () => this.getInventories(0, this.state.selectedClient.id));
        }).catch(error => {
            console.log(error)
            this.props.enqueueSnackbar(this.props.t("error_delete_inventory"), { variant: 'error' });
        });
    }

    render() {

        let { inventories, isOpen, specificsClients, isLoading, selectedClient, inventoryToEdit, deleteDialogOpen, inventoryToDelete } = this.state;

        if (isLoading) {
            return (
                <div className="loading-position">
                    <CircularProgress className="spinner" color="primary" />
                </div>
            )
        }

        let inventoriesList;
        let recordsNotFound;
        if (inventories && inventories.length > 0) {
            inventoriesList = inventories.map((inventory, index) => {
                return <Fragment key={index}>
                    <TableRow style={{ backgroundColor: index === this.state.collapseIndex ? "#E5EBEB" : null }}>
                        <TableCell>
                            <IconButton aria-label="expand row" size="small" onClick={() => this.setState({ collapseIndex: this.state.collapseIndex !== index ? index : -1 })}>
                                {index === this.state.collapseIndex ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                            </IconButton>
                        </TableCell>
                        <TableCell>{inventory.inventoryName}</TableCell>
                        <TableCell>{inventory.inventoryDescription}</TableCell>
                        <TableCell>{inventory.numberOfActiveAssets}</TableCell>
                        <TableCell>{inventory.numberOfInactiveAssets}</TableCell>
                        <TableCell>{inventory.isActive ? <CheckIcon fontSize="small" className="fa fa-plus-circle" style={{ color: 'green' }} /> : <CloseIcon fontSize="small" className="fa fa-plus-circle" style={{ color: 'red' }} />}</TableCell>
                        <TableCell>
                            <Fab title={this.props.t("edit")} onClick={() => this.getInventoryById(inventory.id)} size="small" style={{ marginRight: 10 }} color="secondary" aria-label="edit">
                                <EditIcon />
                            </Fab>
                            <Fab title={this.props.t("change_active_status")} onClick={() => this.changeInventoryStatus(inventory.isActive, inventory.id)} color="default" size="small" style={{ marginRight: 10 }} >
                                {inventory.isActive ? <CloseIcon style={{ color: 'red' }} /> : <CheckIcon style={{ color: 'green' }} />}
                            </Fab>
                            <Fab title={this.props.t("delete")} disabled={inventory.numberOfActiveAssets !== 0 || inventory.numberOfInactiveAssets !== 0} onClick={() => this.setState({ inventoryToDelete: inventory, deleteDialogOpen: true })} size="small" style={{ marginRight: 10 }} color="inherit" aria-label="delete">
                                <DeleteIcon />
                            </Fab>
                        </TableCell>
                    </TableRow>
                    <TableRow>
                        <TableCell style={{ paddingBottom: 0, paddingTop: 0, border: "none" }} colSpan={2}>
                            <Collapse in={index === this.state.collapseIndex ? true : false} timeout="auto" unmountOnExit>
                                <Box margin={1}>
                                    <Link
                                        to={{
                                            pathname: '/summaries',
                                            state: {
                                                selectedInventory: inventory
                                            }
                                        }}
                                        style={{ color: '#00d4ff', textDecoration: 'none', marginLeft: '40px' }}>
                                        {this.props.t("inventory_summary")}
                                    </Link>
                                    {/* <Table aria-label="simple table" size="small">
                                        <TableHead>
                                            <TableRow>
                                                <TableCell className="table-cell-custom" component="th" scope="row" width="35%">{this.props.t("year")}</TableCell>
                                                <TableCell className="table-cell-custom" component="th" scope="row" width="35%">{this.props.t("status")}</TableCell>
                                                <TableCell className="table-cell-custom" align="right" component="th" scope="row" width="30%">
                                                    <Fab onClick={() => this.setState({ isOpenReportingYearModal: true, inventoryId: inventory.id })} size="small" color="secondary">
                                                        <AddIcon />
                                                    </Fab>
                                                </TableCell>
                                            </TableRow>
                                        </TableHead>
                                        <TableBody>
                                            {inventory.reportingYears.map((reportingYear, dindex) => {
                                                return <TableRow key={dindex}>
                                                    <TableCell>
                                                        <Link
                                                            to={{
                                                                pathname: '/summaries',
                                                                state: {
                                                                    selectedInventory: inventory
                                                                }
                                                            }}
                                                            style={{ color: '#00d4ff', textDecoration: 'none' }}>
                                                            {reportingYear.year}
                                                        </Link>
                                                    </TableCell>
                                                    <TableCell>{this.props.t(reportingYear.openStatus)}</TableCell>
                                                    <TableCell>
                                                        <Fab onClick={() => this.changeReportingYearStatus(reportingYear.openStatus === "OPEN" ? "CLOSED" : "OPEN", reportingYear.id)} size="small" style={{ marginRight: 10 }} >
                                                            {reportingYear.openStatus === "CLOSED" ? <CheckIcon style={{ color: 'green' }} /> : <CloseIcon style={{ color: 'red' }} />}
                                                        </Fab>
                                                        <Fab title={this.props.t("delete")} onClick={() => this.setState({ reportingYearToDelete: reportingYear, dialogOpen: true })} size="small" style={{ marginRight: 10 }} color="inherit" aria-label="edit">
                                                            <DeleteIcon />
                                                        </Fab>
                                                    </TableCell>
                                                </TableRow>
                                            })}
                                        </TableBody>
                                    </Table> */}
                                </Box>
                            </Collapse>
                        </TableCell>
                    </TableRow>
                </Fragment>
            });
        } else {
            recordsNotFound = <TableRow>
                <TableCell align="center" colSpan={6}>
                    <p>{this.props.t("no_records_found")}</p>
                </TableCell>
            </TableRow>
        }

        return <Grid container direction="row" spacing={2}>
            <Grid item container direction="column" xs={12} sm={12} md={12} lg={12} xl={12}>
                <CardHeader
                    title={this.props.t("inventories")}
                    action={
                        selectedClient !== null && <Button variant="contained" color="secondary" aria-label="edit" onClick={() => this.setState({ inventoryToEdit: null, isOpen: true })} style={{ top: '4px' }}>
                            {this.props.t("add_new_inventory")}
                        </Button>
                    } />
                <Card>
                    <CardContent>
                        <Grid container direction="row" spacing={2}>
                            <Grid item container direction="column" xs={2} sm={2} md={2} lg={2} xl={2}>
                                <Grid container direction="row" spacing={2}>
                                    <SelectClient
                                        specificsClients={specificsClients}
                                        selectedClient={selectedClient}
                                        handleChange={this.handleChange}
                                    />
                                </Grid>
                            </Grid>
                        </Grid>
                        {selectedClient !== null && <><Grid container direction="row" spacing={2}>
                            <Grid item container direction="column" xs={12} sm={12} md={12} lg={12} xl={12}>
                                <Grid container direction="row" spacing={2}>
                                    <Grid item container>
                                        <TableContainer component={Paper}>
                                            <Table aria-label="simple table" size="small" style={{ tableLayout: 'fixed' }}>
                                                <TableHead>
                                                    <TableRow>
                                                        <TableCell component="th" scope="row" width="10%"></TableCell>
                                                        <TableCell component="th" scope="row" width="25%">{this.props.t("inventory_name")}</TableCell>
                                                        <TableCell component="th" scope="row" width="25%">{this.props.t("inventory_description")}</TableCell>
                                                        <TableCell component="th" scope="row" width="10%">{this.props.t("number_of_active_assets")}</TableCell>
                                                        <TableCell component="th" scope="row" width="10%">{this.props.t("number_of_inactive_assets")}</TableCell>
                                                        <TableCell component="th" scope="row" width="5%">{this.props.t("active")}</TableCell>
                                                        <TableCell component="th" scope="row" width="15%"></TableCell>
                                                    </TableRow>
                                                </TableHead>
                                                <TableBody>
                                                    {inventoriesList}
                                                    {recordsNotFound}
                                                </TableBody>
                                            </Table>
                                        </TableContainer>
                                    </Grid>
                                </Grid>
                            </Grid>
                        </Grid>
                            <TablePagination
                                component="div"
                                count={this.state.totalElements}
                                rowsPerPageOptions={[10, 25, 50, 100]}
                                page={this.state.activePage}
                                onPageChange={this.handleChangePage}
                                rowsPerPage={this.state.rowsPerPage}
                                onRowsPerPageChange={this.handleChangeRowsPerPage}
                                backIconButtonText={this.props.t("previous_page")}
                                labelRowsPerPage={this.props.t("rows_per_page")}
                                nextIconButtonText={this.props.t("next_page")}
                            /></>}
                    </CardContent>
                </Card>
            </Grid>
            <CreateOrUpdateInventory
                isOpen={isOpen}
                onClose={this.closeDialog}
                selectedClient={selectedClient}
                inventoryToEdit={inventoryToEdit ? inventoryToEdit : null}
                getInventories={() => this.getInventories(0, selectedClient.id)}
            />
            {
                inventoryToDelete && <ConfirmationDialog
                    isOpen={deleteDialogOpen}
                    title={this.props.t("delete_inventory")}
                    message={this.props.t("delete_inventory_dialog_message", { inventoryName: inventoryToDelete.inventoryName })}
                    onClose={() => this.setState({ deleteDialogOpen: false })}
                    onConfirm={() => this.setState({ deleteDialogOpen: false }, () => this.deleteInventory())}
                    closeButtonTitle={this.props.t("close")}
                    confirmButtonTitle={this.props.t("delete")}
                />
            }
        </Grid >
    }
}

export default withSnackbar(withTranslation()(Inventories))